import type { HostIps, ValidationContext, ValidationResult } from './types.ts';

export function valid(): ValidationResult {
  return { valid: true, reason: null };
}

export function invalid(reasons: string | string[]): ValidationResult {
  return {
    valid: false,
    reason: Array.isArray(reasons) ? reasons.join('; ') : reasons,
  };
}

export function chromeArgs(context: ValidationContext): string[] | null {
  return context.hostParams ? [...context.hostParams.chromeArgs] : null;
}

export function hostIps(context: ValidationContext): HostIps | null {
  return context.hostParams ? { ...context.hostParams.ips } : null;
}

export function chromeArg(
  args: readonly string[],
  name: string,
): string | null {
  const prefix = `--${name}=`;
  const argument = args.find((item) => item.startsWith(prefix));
  return argument?.slice(prefix.length) ?? null;
}
